import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AnalyticEvents } from '@app/enums';
import { JobAttachment } from '@app/models/recruiting/job-attachments.model';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { JobAttachmentTypes } from '@app/modules/applicant-tracker/enums/job-attachment-types.enum';
import { BaseForm } from '@app/modules/forms/base.form';
import { AnalyticService, NotifyService } from '@app/services';
@Component({
    selector: 'app-job-posting-store-attachments-information',
    templateUrl: './job-posting-store-attachments.form.html',
    styleUrls: ['./job-posting-store-attachments.form.scss'],
})
export class JobPostingStoreAttachments extends BaseForm implements OnInit {
    @Input() jobPosting: JobPosting;
    @Input() hasQuickApply: boolean;
    @Input() jobAttachments: JobAttachment[] = [];
    @Output() attachmentsChanged = new EventEmitter<JobAttachment>();

    jobAttachmentTypes = JobAttachmentTypes;
    maxNumberOfFields = 6;

    constructor(
        private notify: NotifyService,
        private analyticService: AnalyticService
    ) {
        super();
    }

    ngOnInit(): void {
        if (this.jobPosting?.jobAttachments.length > 0) {
            this.jobAttachments = this.jobPosting.jobAttachments;
        }
    }

    addJobPosting(): void {
        if (this.jobAttachments.length > this.maxNumberOfFields) {
            this.notify.error('forms.applicant-tracker.tooManyDocuments');
            return;
        }

        this.analyticService.trackEvent(AnalyticEvents.RecruitingAddDocument);

        const newJobPosting = new JobAttachment({ jobAttachmentTypeId: null, isRequired: false });

        this.jobAttachments.push(newJobPosting);
        this.attachmentsChanged.emit(newJobPosting);
    }

    removeJobPosting(index: number): void {
        const removedJobPosting = this.jobAttachments.splice(index, 1)[0];
        this.attachmentsChanged.emit(removedJobPosting);
        this.analyticService.trackEvent(AnalyticEvents.RecruitingRemoveDocument);
    }

    trackRequired(change: MatCheckboxChange): void {
        if (!change.checked) {
            return;
        }

        this.analyticService.trackEvent(AnalyticEvents.RecruitingMakeDocumentRequired);
    }
}
